<template>
  <div class="card upload-container">
    <div class="upload-form">
      <FloatLabel
        variant="on"
        class="input-wrapper"
      >
        <InputText 
          id="on_label" 
          v-model="resourceUrl"
          style="width: 100%;"
          :disabled="isLoading"
          @keyup.enter="uploadDocuments"
        />
        <label for="on_label">URL</label>
      </FloatLabel>
      <Button 
        type="button" 
        label="Upload" 
        :loading="isLoading"
        :disabled="!resourceUrl || isLoading"
        @click="uploadDocuments"
      />
    </div>
  </div>
</template>
<script>
import FloatLabel from "primevue/floatlabel";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { createAuthenticatedAxiosInstance } from "@/services/api";
import { RESOURCE_TYPE_URL } from "@/assets/constants/constants";
import {
    BASE_URL,
    LIBRARY_RESOURCE_ENDPOINT,
} from "@/assets/constants/api_endpoints";

export default {
    components: {
        FloatLabel,
        InputText,
        Button,
    },
    props: {
        subjectId: {
            type: String,
            default: null
        },
    },
    emits: ['upload-complete', 'show-toast'],
    data() {
        return {
        resourceUrl: null,
        isLoading: false,
        };
    },
    methods: {
        async uploadDocuments() {
        const uploadUrl = BASE_URL + LIBRARY_RESOURCE_ENDPOINT;
        const formData = new FormData();
        formData.append("subject_id", this.subjectId);
        formData.append("resource_type", RESOURCE_TYPE_URL);
        formData.append("resource_url", this.resourceUrl);
        formData.append("file_details", this.resourceUrl);

        this.isLoading = true;
        const axiosInstance = createAuthenticatedAxiosInstance();
        
        try {
            await axiosInstance.post(uploadUrl, formData, {
                headers: {
                "Content-Type": "multipart/form-data",
                },
            });
            this.resourceUrl = null;
            this.$emit("upload-complete");
        } catch (error) {
            console.error("Error uploading resource:", error);
        } finally {
            this.isLoading = false;
        }
        },
    },
};
</script>

<style scoped>
.upload-container {
  padding: 1rem;
}

.upload-form {
  display: flex;
  gap: 0.75rem;
  align-items: flex-end;
}

.input-wrapper {
  flex: 1;
}

.p-button {
  white-space: nowrap;
}
</style>
